<template>
  <div>
    <div class="lesson-list">
      <div class="lesson-list-search">
        <input
          @keypress="searchfun()"
          type="text"
          placeholder="搜索课程"
          v-model="search"
        />
      </div>
      <div class="lesson2">
        <h2 class="tip" v-show="classnum">暂无课程</h2>
        <ul class="lesson2-items">
          <li
            class="lesson2-item"
            v-for="(item, index) in courseList"
            @click="$router.push('/lesson-detail/' + item.course_id)"
          >
            <div class="lesson2-main">
              <div class="lesson2-pic f-img-box">
                <img :src="item.cover_img" />
              </div>
              <div class="lesson2-content">
                <div
                  class="lesson2-name o1"
                  v-if="item.course_teachers[0]"
                  v-text="item.course_teachers[0].nick_name"
                ></div>
                <div class="lesson2-num o1" v-text="item.play_num"></div>
              </div>
            </div>
            <div class="lesson2-text o1" v-text="item.course_title"></div>
          </li>
          <li class="lesson2-item lesson2-item-empty"></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      courseList: [],
      datalength: "",
      search: "",
      page: 1,
      scrollsw: true,
      classnum: false,
    };
  },
  created() {
    //获取课程列表
    //url http://demo-mooc.com/themes/simpleboot3/mooc-wx#/lesson-list/type=1/typeid=0
    //var type = 1; //从url上获取参数type   //type固定值  1分类  2专题  4栏目
    //var type_id = 0; ////从url上获取参数type_id   //type_id  分类id、专题id获取栏目
    var _this = this;
    this.$api.get(
      "",
      {
        api: "/v1/course/index",
        type: this.$route.params.type,
        type_id: this.$route.params.type_id,
        page: this.page,
        len: 12,
        status: 1,
        title: "", //搜索
      },
      (res) => {
        this.courseList = res.data.list;
        //var num = res.data.num;  //课程总数量
        this.datalength = res.data.num;
        // console.log(res.data);
        if (this.datalength == 0) {
          this.classnum = true;
        }
      }
    );
    window.addEventListener("scroll", function () {
      if (!_this.scrollsw) {
        return false;
      }
      let scrollTopH =
        document.body.scrollTop || document.documentElement.scrollTop;
      var clientHeight =
        document.documentElement.scrollTop === 0
          ? document.body.clientHeight
          : document.documentElement.clientHeight;
      var scrollTop =
        document.documentElement.scrollTop === 0
          ? document.body.scrollTop
          : document.documentElement.scrollTop;
      var scrollHeight =
        document.documentElement.scrollTop === 0
          ? document.body.scrollHeight
          : document.documentElement.scrollHeight;
      if (
        scrollTop != 0 &&
        (clientHeight + scrollTop == scrollHeight ||
          clientHeight + scrollTop > scrollHeight)
      ) {
        // if(document.documentElement.scrollTop + window.innerHeight + 100 > document.documentElement.offsetHeight || document.documentElement.scrollTop + window.innerHeight == document.documentElement.offsetHeight) {
        _this.page++;
        _this.$api.get(
          "",
          {
            api: "/v1/course/index",
            type: _this.$route.params.type,
            type_id: _this.$route.params.type_id,
            page: _this.page,
            len: 12,
            status: 1,
            title: _this.search, //搜索
          },
          (res) => {
            //var num = res.data.num;  //课程总数量
            if (res.data.list.length == 0) {
              _this.scrollsw = false;
            } else {
              for (var i in res.data.list) {
                _this.courseList.push(res.data.list[i]);
              }
            }
            // console.log(res.data);
          }
        );
      }
    });
  },
  methods: {
    searchfun(evt) {
      this.page = 1;
      this.scrollsw = true;
      // if(evt.keycode == 13){
      this.$api.get(
        "",
        {
          api: "/v1/course/index",
          type: this.$route.params.type,
          type_id: this.$route.params.type_id,
          page: this.page,
          len: 12,
          status: 1,
          title: this.search, //搜索
        },
        (res) => {
          this.courseList = res.data.list;
          //var num = res.data.num;  //课程总数量
          this.datalength = res.data.num;
          // console.log(res.data);
          if (this.datalength == 0) {
            this.classnum = true;
          }
        }
      );
      // }
    },
  },
  mounted() {},
};
</script>

<style>
.lesson2{
  margin-top: .4rem;
}
.tip {
  padding-top: 1rem;
  font-size: 20px;
  color: #a1a1a1;
  text-align: center;
}

.lesson-list {
  padding: 0.4rem;
}

.lesson-list-search {
  text-align: center;
}

.lesson-list-search input {
  width: 9.173rem;
  height: 0.773rem;
  border-radius: 0.4rem;
  border: 1px solid #ebebeb;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/lesson-list/lesson-list.vue